import React, { useState, useEffect, createContext } from 'react';
import fhirpath from 'fhirpath';

export const UploadSettingsContext = createContext({
    "fileUploadComponentPaths": {
        "idJsonPath": "DocumentReference.id",
        "fileNameJsonPath": "DocumentReference.content[0].attachment.title",
        "fileDescriptionJsonPath": "DocumentReference.description",
        "fileSizeJsonPath": "DocumentReference.content[0].attachment.size",
        "fileUrlJsonPath": "DocumentReference.content[0].attachment.url",
        "fileTypeJsonPath": "DocumentReference.type.text",
        "fileContentTypeJsonPath": "DocumentReference.content[0].attachment.contentType",
        "categoryJsonPath": "DocumentReference.meta.tag[0].code",
        "createdDateJsonPath": "DocumentReference.created",
        "lastModifiedDateJsonPath": "DocumentReference.meta.lastUpdated",
        "sortKeyJsonPath": "DocumentReference.created",
        "fileDisplayName": ["DocumentReference.content[0].title"]
    }
});

export const UploadSettingsProvider = (props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [componentPaths, setComponentPaths] = useState({});

    useEffect(() => {
        getSettings();
    }, []);

    const getSettings = () => {
        return fetch(`/settings.json`).then((response) => {
            return response.json();
        }).then((json) => {
            setIsLoaded(true);
            setComponentPaths(json.fileUploadComponentPaths);
        });
    };

    const getDocumentFileId = (item) => {
        return _evaluate(item, componentPaths.idJsonPath);
    };

    const getDocumentFilename = (item) => {
        return _evaluate(item, componentPaths.fileNameJsonPath);
    };

    const getDocumentUrl = (item) => {
        return _evaluate(item, componentPaths.fileUrlJsonPath);
    };

    const getDocumentDescription = (item) => {
        return _evaluate(item, componentPaths.fileDescriptionJsonPath);
    };

    const getDocumentCategory = (item) => {
        return _evaluate(item, componentPaths.categoryJsonPath);
    };

    const getDocumentFileType = (item) => {
        return _evaluate(item, componentPaths.fileTypeJsonPath);
    };

    const getDocumentContentType = (item) => {
        return _evaluate(item, componentPaths.fileContentTypeJsonPath);
    };

    const getDocumentFileSize = (item) => {
        return _evaluate(item, componentPaths.fileSizeJsonPath);
    };

    const getDocumentCreatedDate = (item) => {
        return _evaluate(item, componentPaths.createdDateJsonPath);
    };

    const getDocumentLastModifiedDate = (item) => {
        return _evaluate(item, componentPaths.lastModifiedDateJsonPath);
    };

    const getDocumentDisplayName = (item) => {
        return _evaluate(item, componentPaths.fileDisplayName);
    }

    const getDocumentHash = (item) => {
        return _evaluate(item, 'DocumentReference.content[0].attachment.hash');
    }

    const getDocumentData = (item) => {
        return _evaluate(item, 'DocumentReference.content[0].attachment.data');
    }

    const getDocumentSortKey = (item) => {
        return _evaluate(item, componentPaths.sortKeyJsonPath);
    }

    const _evaluate = (item, paths) => {
        if (!item) {
            return null;
        }

        if (item.resource) {
            item = item.resource;
        }

        if (typeof (paths) === 'string') {
            return fhirpath.evaluate(item, paths).shift();
        }

        if (paths?.length > 0) {
            for (let key in paths) {
                let value = fhirpath.evaluate(item, paths[key]).shift();

                if (value) {
                    return value;
                }
            }
        }
    };

    return (
        <UploadSettingsContext.Provider value={{
            getDocumentFileId: getDocumentFileId,
            getDocumentFilename: getDocumentFilename,
            getDocumentUrl: getDocumentUrl,
            getDocumentDescription: getDocumentDescription,
            getDocumentCategory: getDocumentCategory,
            getDocumentFileType: getDocumentFileType,
            getDocumentContentType: getDocumentContentType,
            getDocumentFileSize: getDocumentFileSize,
            getDocumentCreatedDate: getDocumentCreatedDate,
            getDocumentLastModifiedDate: getDocumentLastModifiedDate,
            getDocumentDisplayName: getDocumentDisplayName,
            getDocumentHash: getDocumentHash,
            getDocumentData: getDocumentData,
            getDocumentSortKey: getDocumentSortKey
        }}>
            {
                isLoaded ?
                    props.children
                    : null
            }
        </UploadSettingsContext.Provider>
    );
}

export const UploadSettingsConsumer = UploadSettingsContext.Consumer;
